import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import GeneralInventoryDetailItem from '../entities/generalInventoryReportDetailItem'
import Ajax from '../../lib/ajax'
import appconst from './../../lib/appconst';

interface GeneralInventoryDetailState extends ListState<GeneralInventoryDetailItem> {
   
}
class GeneralInventoryDetailModule extends ListModule<GeneralInventoryDetailState, any, GeneralInventoryDetailItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<GeneralInventoryDetailItem>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<GeneralInventoryDetailState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/Inventory/GeneralInventoryDetailReport', { params: payload.data });
            context.state.loading = false;
            context.state.totalCount = result.totalRows;
            context.state.list = result.items;
        },
        async exportDetail(context:ActionContext<GeneralInventoryDetailState,any>,payload:any){
            var url = `${appconst.remoteServiceBaseUrl}report/ExportGeneralInventoryDetailReport${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }), true)}`;
            window.open(url, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: GeneralInventoryDetailState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: GeneralInventoryDetailState, pagesize: number) {
            state.pageSize = pagesize;
        },
        refreshListData(state: GeneralInventoryDetailState)
        {
            state.list = new Array<GeneralInventoryDetailItem>();
        }
    }
}
const generalInventoryReportDetailModule = new GeneralInventoryDetailModule();
export default generalInventoryReportDetailModule;